module.exports = __webpack_public_path__ + "static/img/google.6b49c2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/google.png
// module id = N97r
// module chunks = 1